import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { CONFIG } from '../../constants';
import { DOCTOR_ROLE, LOADING_STATUS } from '../../resources/enums';
import { DoctorModel } from '../../resources/models';
import { switchTranslationResources } from '../../locales/config';

export interface IAuthState {
  token?: string | null;
  account?: DoctorModel;
  profileLoadingStatus: LOADING_STATUS;
  requiresPasswordChange?: boolean;
  isMattressExpert?: boolean;
}

const initialState: IAuthState = {
  token: undefined,
  profileLoadingStatus: LOADING_STATUS.NONE,
  requiresPasswordChange: localStorage.getItem('requiresPasswordChange') === 'true',
  isMattressExpert: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
      if (state.token) {
        localStorage.setItem(CONFIG.TOKEN_KEY, state.token);
      } else {
        localStorage.removeItem(CONFIG.TOKEN_KEY);
        state.account = null;
        state.requiresPasswordChange = false;
        localStorage.removeItem('requiresPasswordChange');
        localStorage.removeItem('pendingPasswordChangeEmail');
        state.isMattressExpert = false;
        switchTranslationResources(false);
      }
    },
    setAccount: (state, action: PayloadAction<DoctorModel | null>) => {
      state.account = action.payload;
      state.isMattressExpert = action.payload?.doctorRole === DOCTOR_ROLE.MATRATZEN_EXPERT;
    },
    patchAccount: (state, action: PayloadAction<Partial<DoctorModel>>) => {
      state.account = {
        ...state.account,
        ...action.payload,
      };
    },
    setProfileLoadingStatus: (state, action: PayloadAction<LOADING_STATUS>) => {
      state.profileLoadingStatus = action.payload;
    },
    setRequiresPasswordChange: (state, action: PayloadAction<boolean>) => {
      state.requiresPasswordChange = action.payload;
      if (action.payload) {
        localStorage.setItem('requiresPasswordChange', 'true');
      } else {
        localStorage.removeItem('requiresPasswordChange');
      }
    },
  },
});

export const { setToken, setAccount, patchAccount, setProfileLoadingStatus, setRequiresPasswordChange } =
  authSlice.actions;

export default authSlice.reducer;
